module.exports = __webpack_public_path__ + "img/19.442cfe1c.jpg";